export const PerPageOptions = [10, 20, 50, 100];
export const Order = {
  desc: 'desc',
  asc: 'asc',
};
